import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import AestheticBundles from "./sections/AestheticBundles";
import PassionForPerfection from "./sections/PassionForPerfection";
import TheLeadershipTeam from "./sections/TheLeadershipTeam";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <AestheticBundles />
      <PassionForPerfection />
      <TheLeadershipTeam />
      <Footer />
    </div>;
}